import script from "./SubDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./SubDefault.vue?vue&type=script&setup=true&lang=js"

import "./SubDefault.vue?vue&type=style&index=0&id=01a1b8a6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a1b8a6"]])

export default __exports__